export enum ModifierOperationType {
	Additive = 1,
	Multiplicative = 2,
}
